if (!customElements.get('accordion-item')) {
  class AccordionItem extends customElements.get(
    'dropdown-disclosure'
  ) {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        if (!this.hasAttribute('data-expanded')) {
          this.querySelector('details').open = false;
        }
        this.init();
      });
    }

    /**
     * An accordion is not a popup, so unlike the base dropdown it must not
     * trap focus inside the open panel; Tab should move on to the page.
     * @override
     */
    open(summaryElement, detailsElement) {
      setTimeout(() => {
        detailsElement.classList.add('is-open');
      });
      summaryElement.setAttribute('aria-expanded', true);
    }
  }

  customElements.define('accordion-item', AccordionItem);
}
